import React, { useState } from 'react';
import IMerchProductOrderItem from '../../../../../../models/restful/IMerchProductOrderItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Popover, Overlay } from 'react-bootstrap';
import { apiV2 } from '../../../../../../api/ApiV2';

interface IDesignActionsProps {
  orderItem: IMerchProductOrderItem;
  onUpdate: () => void;
}

type ActionType = 'duplicate' | 'delete' | null;

const DesignActions: React.FC<IDesignActionsProps> = ({
  orderItem,
  onUpdate
}) => {
  const [currentAction, setCurrentAction] = useState<ActionType>(null);
  const [targetElement, setTargetElement] = useState<HTMLElement | null>(null);

  const duplicateOrderItem = async () => {
    try {
      await apiV2.order.createOrderItem({
        orderItem: {
          ProductID: orderItem.ProductID,
          OrderID: orderItem.OrderID
        } as IMerchProductOrderItem
      });
      onUpdate();
      setTargetElement(null);
    } catch (error) {
      console.error('Failed to duplicate order item:', error);
    }
  };

  const deleteOrderItem = async () => {
    try {
      await apiV2.order.deleteOrderItem({
        id: orderItem.ID
      });
      onUpdate();
      setTargetElement(null);
    } catch (error) {
      console.error('Failed to delete order item:', error);
    }
  };

  const handleActionClick = (action: ActionType, element: HTMLElement) => {
    setCurrentAction(action);
    setTargetElement(element);
  };

  const handleConfirm = () => {
    if (currentAction === 'duplicate') {
      duplicateOrderItem();
    } else if (currentAction === 'delete') {
      deleteOrderItem();
    }
  };

  return (
    <div className="design-card__actions">
      <button
        className="btn btn-outline-success btn-sm"
        onClick={e => handleActionClick('duplicate', e.currentTarget)}
      >
        <FontAwesomeIcon icon={faCopy} className="me-2" />
        Duplicate
      </button>

      <button
        className="btn btn-outline-danger btn-sm"
        onClick={e => handleActionClick('delete', e.currentTarget)}
      >
        <FontAwesomeIcon icon={faTrash} className="me-2" />
        Delete
      </button>

      <Overlay
        show={!!targetElement}
        target={targetElement}
        placement="top-end"
      >
        <Popover>
          <Popover.Body>
            <p className="mb-0">
              {currentAction === 'duplicate'
                ? 'Create a copy of this design?'
                : 'Remove this design?'}
            </p>
            <div className="d-flex justify-content-end gap-2 mt-2">
              <button
                className="btn btn-sm btn-light"
                onClick={() => setTargetElement(null)}
              >
                Cancel
              </button>
              <button
                className={`btn btn-sm btn-${
                  currentAction === 'duplicate' ? 'success' : 'danger'
                }`}
                onClick={handleConfirm}
              >
                {currentAction === 'duplicate' ? 'Copy' : 'Remove'}
              </button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};

export default DesignActions;
